const FormResources = {

    form_data:{
        name:           '',
        description:    '',
        room_type_id:   [],
        status: 1,
    },

    form_format:[
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  200,
            disabled:   false,
            step:       '',
            name:       'Name:',
            model_name: 'name',
            ref:        'name_input',
            ref_alt:    'name_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  200,
            disabled:   false,
            step:       '',
            name:       'Description:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'switch',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Active:',
            model_name: 'status',
            ref:        'status_input',
            ref_alt:    'status_input_alt',
            required:   false,
        },
    ],
    
    status_options: [
        {
            id: 3, 
            name: 'All'
        },
        {
            id: 1, 
            name: 'Active'
        },
        {
            id: 0, 
            name: 'Inactive'
        },
    ]

}

export default FormResources;